<template lang="pug">
  .component-tabbed-client-transactions
    ActionBar
      h2(slot="title") Payment Methods
      i.fa.fa-plus-circle.fa-2x(data-toggle="create-payment", slot="action")
    .tabs-inner-content
      #create-payment.is-hidden(data-toggler="is-hidden", v-f="")
        p Select offline payment provider
        select(v-model="payment_provider")
          option offline
          option test-pass
          option test-fail
        ActionButton(:action="handleCreatePayment" ) Create
      base-list(:component="component", :dataLoader="dataLoader", ref="loader")
</template>
<script type="text/babel">
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import BaseList from '../../../pages/backoffice/BaseList'
  import MaggieHelper from '../../../maggieHelper'
  import ActionBar from '../../structure/ui/ActionBar'
  import ActionButton from '../../structure/ui/ActionButton'

  export default {
    name: 'TabbedClientPaymentMethods',
    components: {ActionButton, ActionBar, BaseList},
    data() {
      return {
        component: require('src/components/backoffice/PaymentMethod.vue'),
        payment_provider: ''
      }
    },
    created() {
    },
    methods: {
      dataLoader(callback, page, resultsPerPage) {
        KeplerBackofficeSdk.clients.list(page, resultsPerPage, {id: this.$route.params.id}).paymentMethods((data) => {
          callback(data)
        })
      },
      handleCreatePayment() {
        return KeplerBackofficeSdk.payment_methods.make({
          'provider': this.payment_provider,
          'client_id': this.$route.params.id
        }, (success) => {
          MaggieHelper.notification('payment-method-esit', 'Payment method added')
          this.$refs.loader.loadData()
        })
      }
    },
    computed: {},
    props: ['defaultOnWallet']
  }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// ClientPaymentMethods.vue?168be3d6